import { render, staticRenderFns } from "./cookie-scripts-in-category-card.vue?vue&type=template&id=0407ac20"
import script from "./cookie-scripts-in-category-card.vue?vue&type=script&lang=js"
export * from "./cookie-scripts-in-category-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports